import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { URLParameterHandler } from "@/utils";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import { CustomerTestimonials } from "./components/dashboard";
import FAQ from "./components/FAQ";
import { Footer } from "./components/Footer";
import { Header } from "./components/Header";
import { NonAffiliationDisclaimer } from "./components/NonAffiliationDisclaimer";
import { ScrollToTop } from "./components/ScrollToTop";
import { SignOutPage } from "./pages/auth/sign-out-page";
import { EmailThankYouPage } from "./pages/email-thank-you";
import { FollowUpEmailThankYouPage } from "./pages/follow-up-email-thank-you";
import { QuoteNotFoundPage } from "./pages/quote-not-found-page";
import { SecurePage } from "./pages/secure-page";
import { SuccessPage } from "./pages/success-page";
import { ViewOfferPage } from "./pages/view-offer-page";
import { OrderSummaryPage } from "./pages/order-summary-page";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <ScrollToTop />
        <URLParameterHandler>
          <Header />

          <div className="min-h-screen bg-background">
            <Routes>
              {/* MVP Routes */}
              <Route path="/secure" element={<SecurePage />} />

              <Route path="/sign-out" element={<SignOutPage />} />
              <Route path="/view-offer" element={<ViewOfferPage />} />
              <Route path="/order-summary" element={<OrderSummaryPage />} />  

              <Route path="/checkout-success" element={<SuccessPage />} />

              <Route path="/thank-you" element={<SuccessPage />} />
              <Route path="/quote-not-found" element={<QuoteNotFoundPage />} />

              <Route path="/email-thank-you" element={<EmailThankYouPage />} />

              <Route
                path="/follow-up-email-thank-you"
                element={<FollowUpEmailThankYouPage />}
              />

              {/* Catch all route */}
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>

            <CustomerTestimonials />
            <FAQ />
            <Footer />
          </div>

          <NonAffiliationDisclaimer />
        </URLParameterHandler>
      </Router>
    </QueryClientProvider>
  );
}

export default App;
